import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";

// Pages
import Main from "./pages/Main";
import Home from "./pages/Home";
import AboutVision from "./pages/about/AboutVision";
import AboutHistory from "./pages/about/AboutHistory";
import AboutTechnology from "./pages/about/AboutTechnology";
import AboutClients from "./pages/about/AboutClients";
import AboutLocation from "./pages/about/AboutLocation";
import BusinessAlimtalk from "./pages/business/BusinessAlimtalk";
import BusinessRcs from "./pages/business/BusinessRcs";
import BusinessMail from "./pages/business/BusinessMail";
import BusinessAsp from "./pages/business/BusinessAsp";
import BusinessIntegration from "./pages/business/BusinessIntegration";
import BusinessAdmin from "./pages/business/BusinessAdmin";
import BusinessAICC from "./pages/business/BusinessAICC";
import ServiceSubmit from "./pages/service/ServiceSubmit";
import ServiceMessaging from "./pages/service/ServiceMessaging";
import ServiceAicc from "./pages/service/ServiceAicc";
import ServiceTest from "./pages/service/ServiceTest";
import VocSubmit from "./pages/voc/VocSubmit";
import VocCheck from "./pages/voc/VocCheck";
import VocView from "./pages/voc/VocView";
import Terms from "./pages/policy/Terms";
import Privacy from "./pages/policy/Privacy";
import EmailRefusal from "./pages/policy/EmailRefusal";
import Sitemap from "./pages/policy/Sitemap";
import BusinessMessaging from "./pages/business/BusinessMessaging";
import {
  ServiceMessaging as ServiceProvideMessaging,
  ServiceAICC as ServiceProvideAICC,
  ServiceVoucherAICC as ServiceProvideVoucherAICC,
} from "./pages/service-provide";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* 홈 */}
        <Route index element={<Main />} />
        <Route path="home" element={<Home />} />

        {/* 회사소개 */}
        <Route path="about/vision" element={<AboutVision />} />
        <Route path="about/history" element={<AboutHistory />} />
        <Route path="about/technology" element={<AboutTechnology />} />
        <Route path="about/clients" element={<AboutClients />} />
        <Route path="about/location" element={<AboutLocation />} />

        {/* 사업분야 */}
        <Route path="business/messaging" element={<BusinessMessaging />} />
        <Route path="business/alimtalk" element={<BusinessAlimtalk />} />
        <Route path="business/rcs" element={<BusinessRcs />} />
        <Route path="business/mail" element={<BusinessMail />} />
        <Route path="business/asp" element={<BusinessAsp />} />
        <Route path="business/integration" element={<BusinessIntegration />} />
        <Route path="business/admin" element={<BusinessAdmin />} />
        <Route path="business/aicc" element={<BusinessAICC />} />

        {/* 서비스 소개 (새로운) */}
        <Route path="service-provide/messaging" element={<ServiceProvideMessaging />} />
        {/* <Route path="service-provide/voucher-aicc" element={<ServiceProvideAICC />} /> */}
        <Route path="service-provide/voucher-aicc" element={<ServiceProvideVoucherAICC />} />

        {/* 서비스 신청 */}
        <Route path="service/messaging" element={<ServiceMessaging />} />
        <Route path="service/aicc" element={<ServiceAicc />} />
        <Route path="service/test" element={<ServiceTest />} />
        <Route path="service/submit" element={<ServiceSubmit />} />

        {/* VOC */}
        <Route path="voc/submit" element={<VocSubmit />} />
        <Route path="voc/check" element={<VocCheck />} />
        <Route path="voc/view" element={<VocView />} />

        {/* 정책 */}
        <Route path="policy/terms" element={<Terms />} />
        <Route path="policy/privacy" element={<Privacy />} />
        <Route path="policy/email-refusal" element={<EmailRefusal />} />
        <Route path="policy/sitemap" element={<Sitemap />} />
      </Route>
    </Routes>
  );
}

export default App;
